import { Icons, formatUptime, isValidCellSignal, isValidHumidity, HardwareStatusCardData } from "@app/shared";
import { DataInfoCard } from "./DataInfoCard";

type HardwareStatusCardsProps = {
    data: HardwareStatusCardData;
    className?: string;
};

export const HardwareStatusCards: React.FC<HardwareStatusCardsProps> = ({ data, className }) => {
    const hasCellSignal = isValidCellSignal(data.cellSignal);
    const hasHumidity = isValidHumidity(data.humidity);

    // A row from lg up; below that the cards tile two-up, then one-up on a phone. As a flex row
    // they never wrapped, so a phone showed the first card and half of the second with the rest
    // scrolling sideways inside the page.
    return (
        <div className={className ?? "grid grid-cols-1 sm:grid-cols-2 lg:flex gap-4"}>
            {data.status && (
                <DataInfoCard Icon={Icons.NetworkWired} title="Status" hoverText={data.statusHoverText}>
                    {data.status}
                </DataInfoCard>
            )}
            {!data.isDisconnected && (
                <>
                    <DataInfoCard Icon={Icons.HardwareChipOutline} title="CPU Usage">
                        {data.cpuUsage !== undefined ? `${data.cpuUsage.toFixed(1)} %` : "— %"}
                    </DataInfoCard>
                    <DataInfoCard Icon={Icons.StopWatch} title="Uptime">
                        {formatUptime(data.uptime)}
                    </DataInfoCard>
                    {hasCellSignal && (
                        <DataInfoCard Icon={Icons.Cellular} title="Cell Signal">
                            {data.cellSignal} %
                        </DataInfoCard>
                    )}
                    {!hasCellSignal && hasHumidity && (
                        <DataInfoCard Icon={Icons.Humidity} title="Humidity">
                            {data.humidity?.toFixed(1)} %
                        </DataInfoCard>
                    )}
                </>
            )}
            {data.isDisconnected && data.lastHeartbeat && (
                <DataInfoCard Icon={Icons.MessageArrows} title="Last Heartbeat">
                    {data.lastHeartbeat}
                </DataInfoCard>
            )}
        </div>
    );
};
